import { deviceTimezone } from "./constraintsGrid"

const DEVICE_TIMEZONE_HEADER = "X-Device-Timezone"

/** How long the device timezone read is kept: the app opens with a burst of requests. */
const DEVICE_TIMEZONE_TTL_MS = 60 * 1000
let deviceTimezoneRead = { value: null, at: 0 }

const currentDeviceTimezone = () => {
    const now = Date.now()
    if (now - deviceTimezoneRead.at > DEVICE_TIMEZONE_TTL_MS) {
        deviceTimezoneRead = { value: deviceTimezone(), at: now }
    }
    return deviceTimezoneRead.value
}

/**
 * The header that makes the account timezone follow the device's, for a request
 * to our API — read again every minute, so a trip is followed without relaunching
 * the app (the IP geolocates too badly to say it). Empty when the device can't
 * tell (nothing moves then); for a third-party host, where a custom header costs
 * a CORS preflight that host may refuse; and in parent mode: the account is the
 * student's, and the parent's phone says where the parent is, not the student.
 */
export const deviceTimezoneHeaders = ({
    url,
    apiUrl,
    parentMode = false,
    timezone = currentDeviceTimezone(),
}) => {
    const target = String(url ?? "")
    const toOurApi =
        !/^https?:\/\//.test(target) || (!!apiUrl && target.startsWith(apiUrl))

    return toOurApi && !parentMode && timezone
        ? { [DEVICE_TIMEZONE_HEADER]: timezone }
        : {}
}

/** « Europe/Oslo » → « Oslo », « America/Argentina/Buenos_Aires » → « Buenos Aires ». */
export const timezoneCity = (timezone) =>
    String(timezone ?? "")
        .split("/")
        .pop()
        .replace(/_/g, " ")

/**
 * The city of the account's timezone: from the French label the server sends
 * (`timezone_label`, « Europe/Londres » → « Londres »), else from the identifier.
 * `null` when the account has no timezone.
 */
export const accountTimezoneCity = (timezone, label) =>
    timezone ? timezoneCity(label ?? timezone) : null
